import React, { useState, useEffect } from "react";
import CustomEditor from "../components/CustomEditor";
import { supabase } from "../supabaseClient";
import "./AdminPanel.css";

const carData = {
  Audi: ["A1","A3","A4","A5","A6","A7","A8","e-tron GT","Q2","Q3","Q4 e-tron","Q5","Q6 e-tron","Q7","Q8 e-tron"],
  Volkswagen: ["Polo","Golf","Passat","Jetta","Tiguan","T-Cross","T-Roc","Taigo","Touareg","Arteon","ID.3","ID.4","ID.5","ID.7","ID. Buzz","Caddy","Multivan","Amarok"],
  SEAT: ["Ibiza","Cordoba","Leon","Alhambra","Arosa","Ateca","Toledo","Altea","Arona","Tarraco","Mii"],
  Porsche: ["718","911","Taycan","Panamera","Macan","Cayenne","918 Spyder"],
  Škoda: ["Fabia","Scala","Octavia","Superb","Kamiq","Karoq","Kodiaq","Enyaq"],
  BMW: ["1 Serisi","2 Serisi","3 Serisi","4 Serisi","5 Serisi","6 Serisi","7 Serisi","8 Serisi","Z4","X1","X2","X3","X4","X5","X6","X7","i4","i5","i7","iX","iX M","M2","M3","M4","M5","M8","XM"],
  Mercedes: ["A-Serisi Hatchback","A-Serisi Sedan","B-Serisi","C-Serisi","C-Serisi All‑Terrain","CLA","CLA Shooting Brake","CLC","CLE Coupé","CLE Cabriolet","E-Serisi","E-Serisi Estate","EQE","EQS","GLA","GLB","GLC","GLC Coupé","GLE","GLS","G-Serisi","AMG GT 4-Kapı Coupé","AMG SL","Maybach S-Serisi","S-Serisi"]
};

const ADMIN_PASSWORD = "erenotogizliadmin123!_!";

function AdminPanel() {
  const [isAuthorized, setIsAuthorized] = useState(false);
  const [password, setPassword] = useState("");
  const [exchangeRate, setExchangeRate] = useState(35);
  const [announcement, setAnnouncement] = useState(localStorage.getItem("announcement") || "");
  const [parts, setParts] = useState([]);
  const [form, setForm] = useState({
    name: "",
    euro: "",
    imageFiles: [],
    oem: "",
    stock: "",
    description: "",
    compatibleVehicles: [],
    currentBrand: "",
    currentModel: "",
    yearFrom: "",
    yearTo: "",
    existingImages: []
  });
  const [oemQuery, setOemQuery] = useState("");

  useEffect(() => {
    const fetchExchangeRate = async () => {
      const { data, error } = await supabase.from("site_settings").select("exchange_rate").limit(1).single();
      if (!error) setExchangeRate(data.exchange_rate);
    };
    const fetchParts = async () => {
      const { data } = await supabase.from("parts").select("*").order("created_at", { ascending: false });
      setParts(data);
    };
    fetchExchangeRate();
    fetchParts();
  }, []);


  const handleLogin = () => {
    if (password === ADMIN_PASSWORD) setIsAuthorized(true);
    else alert("Hatalı şifre!");
  };

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (name === "imageFiles") {
      setForm(prev => ({ ...prev, imageFiles: Array.from(files) }));
    } else if (name === "exchangeRate") {
      setExchangeRate(parseFloat(value));
    } else {
      setForm(prev => ({ ...prev, [name]: value }));
    }
  };

const updateExchangeRate = async () => {
  const { data, error } = await supabase
    .from("site_settings")
    .select("id")
    .limit(1)
    .maybeSingle();

  if (error || !data) {
    alert("Kur güncellenemedi: Kayıt bulunamadı.");
    return;
  }

  const { error: updateError } = await supabase
    .from("site_settings")
    .update({
      exchange_rate: exchangeRate,
      updated_at: new Date()
    })
    .eq("id", data.id);

  if (!updateError) {
    alert(`Kur güncellendi: 1 EUR = ${exchangeRate} ₺`);
  } else {
    alert("Kur güncellenemedi.");
  }
};

  const uploadImagesToStorage = async () => {
    const urls = [];
    for (const file of form.imageFiles) {
      const ext = file.name.split('.').pop();
      const path = `${Date.now()}-${Math.random().toString(36).slice(2)}.${ext}`;
      const { error } = await supabase.storage.from("parts-images").upload(path, file);
      if (!error) {
        const { data } = supabase.storage.from("parts-images").getPublicUrl(path);
        urls.push(data.publicUrl);
      }
    }
    return urls;
  };

  const handleAddPart = async () => {
    if (!form.name || !form.euro || !form.stock) return alert("Tüm alanlar zorunlu.");
    const euro = parseFloat(form.euro);
    const tl = Math.ceil((euro * exchangeRate) / 50) * 50;
    const newImages = await uploadImagesToStorage();
    const finalImages = [...form.existingImages, ...newImages];

    const payload = {
      name: form.name,
      euro,
      tl,
      oem: form.oem,
      stock: parseInt(form.stock),
      description: form.description,
      compatible_vehicles: form.compatibleVehicles,
      image_urls: finalImages
    };

    const { error } = await supabase.from("parts").insert(payload);
    if (error) return alert("Parça eklenemedi.");

    const { data } = await supabase.from("parts").select("*").order("created_at", { ascending: false });
    setParts(data);
    setForm({ name: "", euro: "", imageFiles: [], oem: "", stock: "", description: "", compatibleVehicles: [], currentBrand: "", currentModel: "", yearFrom: "", yearTo: "", existingImages: [] });
  };

  const addCompatibility = () => {
    const { currentBrand, currentModel, yearFrom, yearTo } = form;
    if (currentBrand && currentModel && yearFrom && yearTo) {
      const item = { brand: currentBrand, model: currentModel, yearFrom, yearTo };
      setForm(prev => ({ ...prev, compatibleVehicles: [...prev.compatibleVehicles, item], currentBrand: "", currentModel: "", yearFrom: "", yearTo: "" }));
    }
  };

  const removeCompatibility = (i) => {
    const updated = [...form.compatibleVehicles];
    updated.splice(i, 1);
    setForm(prev => ({ ...prev, compatibleVehicles: updated }));
  };

  const updateStock = async (id, stock, diff) => {
    const newStock = Math.max(0, stock + diff);
    await supabase.from("parts").update({ stock: newStock }).eq("id", id);
    const { data } = await supabase.from("parts").select("*").order("created_at", { ascending: false });
    setParts(data);
  };

  const handleDelete = async (id) => {
    await supabase.from("parts").delete().eq("id", id);
    const { data } = await supabase.from("parts").select("*").order("created_at", { ascending: false });
    setParts(data);
  };

  if (!isAuthorized) {
    return (
      <div className="container py-5 text-center">
        <h2 className="mb-4">Admin Girişi</h2>
        <input type="password" className="form-control w-25 mx-auto mb-3" placeholder="Şifre" value={password} onChange={(e) => setPassword(e.target.value)} />
        <button className="btn btn-primary" onClick={handleLogin}>Giriş Yap</button>
      </div>
    );
  }

  return (
    <div className="container py-4">
      <h2 className="mb-4">Admin Paneli</h2>

      <div className="mb-4">
        <h4>1 Euro = {exchangeRate} ₺</h4>
        <input type="number" className="form-control mb-3" name="exchangeRate" placeholder="Güncel Euro Kuru" value={exchangeRate} onChange={handleChange} />
        <button className="btn btn-outline-primary mb-3" onClick={updateExchangeRate}>Kuru Güncelle</button>

        <h4>Duyuru Metni</h4>
        <CustomEditor value={announcement} onChange={(val) => setAnnouncement(val)} />
        <button className="btn btn-info mt-2" onClick={() => {
          localStorage.setItem("announcement", announcement);
          alert("Duyuru kaydedildi.");
        }}>Duyuruyu Kaydet</button>
      </div>

       <div className="mb-4">
        <h4>Parça Ekle</h4>
        <input className="form-control mb-2" name="name" placeholder="Parça Adı" value={form.name} onChange={handleChange} />
        <input className="form-control mb-2" name="euro" placeholder="Fiyat (€)" type="number" value={form.euro} onChange={handleChange} />
        <input className="form-control mb-2" name="stock" placeholder="Stok" type="number" value={form.stock} onChange={handleChange} />
        <input className="form-control mb-2" name="oem" placeholder="OEM Kodu" value={form.oem} onChange={handleChange} />
        <input className="form-control mb-2" name="imageFiles" type="file" accept="image/*" multiple onChange={handleChange} />
        <CustomEditor value={form.description} onChange={(val) => setForm(prev => ({ ...prev, description: val }))} />

        <div className="row g-2 mt-3">
          <div className="col-md-3">
            <select className="form-select" name="currentBrand" value={form.currentBrand} onChange={handleChange}>
              <option value="">Marka</option>
              {Object.keys(carData).map((brand) => <option key={brand}>{brand}</option>)}
            </select>
          </div>
          <div className="col-md-3">
            <select className="form-select" name="currentModel" value={form.currentModel} onChange={handleChange} disabled={!form.currentBrand}>
              <option value="">Model</option>
              {form.currentBrand && carData[form.currentBrand].map((m) => <option key={m}>{m}</option>)}
            </select>
          </div>
          <div className="col-md-3">
            <input className="form-control" name="yearFrom" placeholder="Yıl (Başlangıç)" type="number" value={form.yearFrom} onChange={handleChange} />
          </div>
          <div className="col-md-3">
            <input className="form-control" name="yearTo" placeholder="Yıl (Bitiş)" type="number" value={form.yearTo} onChange={handleChange} />
          </div>
        </div>

        <button className="btn btn-secondary mt-2" onClick={addCompatibility}>Uyumlu Araç Ekle</button>
        <ul className="list-group mt-2">
          {form.compatibleVehicles.map((v, i) => (
            <li key={i} className="list-group-item d-flex justify-content-between">
              {v.brand} {v.model} - {v.yearFrom} → {v.yearTo}
              <button className="btn btn-sm btn-danger" onClick={() => removeCompatibility(i)}>Sil</button>
            </li>
          ))}
        </ul>
        <button className="btn btn-success mt-3 w-100" onClick={handleAddPart}>Parçayı Kaydet</button>
      </div>

      <div className="parts-list">
        <h4>Eklenen Parçalar</h4>
        <div className="mb-3 d-flex justify-content-end">
          <input type="text" className="form-control w-50" placeholder="OEM kodu ile ara..." value={oemQuery} onChange={(e) => setOemQuery(e.target.value)} />
        </div>
        <ul className="list-group">
          {parts.filter(p => p.oem?.toLowerCase().includes(oemQuery.toLowerCase())).map((p) => {
            const tlLive = Math.ceil((parseFloat(p.euro) * exchangeRate) / 50) * 50;
            return (
              <li key={p.id} className="list-group-item d-flex align-items-center justify-content-between">
                <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
                  <img src={p.image_urls && p.image_urls[0] ? p.image_urls[0] : "/placeholder.jpg"} alt={p.name} style={{ width: 80, height: 80, objectFit: 'cover', borderRadius: 6 }} />
                  <div>
                    <strong>{p.name}</strong><br />
                    TL: {tlLive} ₺ — OEM: {p.oem}<br />
                    <span className={`badge ${p.stock > 0 ? "bg-success" : "bg-danger"}`}>Stok: {p.stock}</span>
                  </div>
                </div>
                <div>
                  <button className="btn btn-sm btn-outline-secondary me-1" onClick={() => updateStock(p.id, p.stock, -1)}>-</button>
                  <button className="btn btn-sm btn-outline-secondary me-2" onClick={() => updateStock(p.id, p.stock, 1)}>+</button>
                  <button className="btn btn-sm btn-danger" onClick={() => handleDelete(p.id)}>Sil</button>
                </div>
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
}

export default AdminPanel;
